import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const applicationDocument = {
  state: {
    applicationDocuments: [],
    selectedApplicationDocument: {},
    selectedApplicationDocumentOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    applicationDocuments(state) {
      return state.applicationDocuments
    },
    selectedApplicationDocument(state) {
      return state.selectedApplicationDocument
    },
    selectedApplicationDocumentOriginal(state) {
      return state.selectedApplicationDocumentOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    applicationDocuments(state, payload) {
      state.applicationDocuments = payload
    },
    selectedApplicationDocument(state, payload) {
      state.selectedApplicationDocument = JSON.parse(JSON.stringify(payload))
    },
    selectedApplicationDocumentOriginal(state, payload) {
      state.selectedApplicationDocumentOriginal = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedApplicationDocument(context, payload) {
      context.commit('selectedApplicationDocument', payload)
    },
    async loadApplicationDocuments(context, payload) {
      const url = 'ApplicationDocument'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('applicationDocuments', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    refreshSelectedApplicationDocument(context, payload) {
      if (context.state.selectedApplicationDocument && context.state.selectedApplicationDocument.Id > 0) {
        context.dispatch('loadSelectedApplicationDocument', context.state.selectedApplicationDocument.Id)

      }
    },
    async loadSelectedApplicationDocument(context, payload) {
      if (context.state.selectedApplicationDocument && context.state.selectedApplicationDocument.Id != payload) {
        context.commit('selectedApplicationDocument', {})
      }
      const url = 'ApplicationDocument/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedApplicationDocument', res.data)
        context.commit('selectedApplicationDocumentOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    clearLookupCacheAndReloadApplicationDocuments(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
          context.dispatch('loadApplicationDocuments')
      }, )
    },
    async createApplicationDocument(context, payload){
      const url = `ApplicationDocument`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'application document created',},{ root: true })
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadApplicationDocuments')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchApplicationDocument(context, payload){
      var item = context.state.selectedApplicationDocument
      if (payload.Id && 
      payload.Id == context.state.selectedApplicationDocumentOriginal.Id)  {
      item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedApplicationDocumentOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(
              original,
              current
            )
        patchPayload.patchDoc = diff

      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `ApplicationDocument/${ patchPayload.Id }`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios
          .patch(url, patchPayload.patchDoc)
          context.dispatch('messages/toastMessage',
          {color: 'success', message: 'application document updated',},{ root: true })
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadApplicationDocuments')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateApplicationDocument(context, payload){
      const url = `ApplicationDocument/${ payload.Id }`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios
          .put(url, payload)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'application document updated',},{ root: true })
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadApplicationDocuments')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveApplicationDocument(context, payload){
      if (payload.Id > 0) {
        return context.dispatch('updateApplicationDocument', payload)
      } else {
        return context.dispatch('createApplicationDocument', payload)
      }
    },
    async deleteApplicationDocument(context, payload){
      const url = `ApplicationDocument/${ payload.Id }`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'application document deleted',},{ root: true })
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadApplicationDocuments')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default applicationDocument